import { Skeleton } from '@repo/videa-components/src/ui/skeleton';

export function LoadingSkeleton() {
  return (
    <div className="vai-w-[1150px] vai-max-w-[1150px] vai-overflow-y-auto vai-max-h-[90vh]">
      {/* Header */}
      <div className="vai-mb-4">
        <Skeleton className="vai-h-6 vai-w-[200px]" />
      </div>

      {/* Main content grid */}
      <div className="vai-grid vai-grid-cols-[1fr_1fr] vai-gap-4 vai-h-full">
        {/* Left column - Patient Information */}
        <div className="vai-p-4 vai-rounded-lg">
          <Skeleton className="h-6 w-[180px] vai-mb-4" />

          {/* Form fields */}
          <div className="vai-space-y-4">
            <div className="vai-flex vai-items-center vai-gap-2">
              <Skeleton className="vai-h-4 vai-w-32" />
              <Skeleton className="vai-h-10 vai-w-full" />
            </div>
            <div className="vai-flex vai-items-center vai-gap-2">
              <Skeleton className="vai-h-4 vai-w-32" />
              <Skeleton className="vai-h-10 vai-w-full" />
            </div>
            <div className="vai-flex vai-items-center vai-gap-2">
              <Skeleton className="vai-h-4 vai-w-32" />
              <Skeleton className="vai-h-10 vai-w-full" />
            </div>
            <div className="vai-flex vai-items-center vai-gap-2">
              <Skeleton className="vai-h-4 vai-w-32" />
              <Skeleton className="vai-h-[200px] vai-w-full" />
            </div>
          </div>
        </div>

        {/* Right column - Teeth Selection & Options */}
        <div className="vai-p-4 vai-rounded-lg vai-overflow-y-auto">
          <Skeleton className="vai-h-6 vai-w-[210px] vai-mb-4" />
          {/* Odontogram skeleton */}
          <Skeleton className="vai-h-[200px] vai-mb-4" />

          {/* Finding types section */}
          <Skeleton className="vai-h-6 vai-w-[280px] vai-mb-2" />
          <div className="vai-grid vai-grid-cols-2 vai-gap-3 vai-mb-4">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="vai-h-6 vai-w-full" />
            ))}
          </div>

          {/* Image sets section */}
          <Skeleton className="vai-h-6 vai-w-[210px] vai-mb-2" />
          <Skeleton className="vai-h-12 vai-w-full vai-mb-2" />
          <div className="vai-grid vai-grid-cols-2 vai-gap-3">
            {[...Array(2)].map((_, i) => (
              <Skeleton key={i} className="vai-h-6 vai-w-full" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
